import { render, staticRenderFns } from "./ResolDeltaSolBs4_1d03.vue?vue&type=template&id=c210b7d8&"
import script from "./ResolDeltaSolBs4_1d03.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolBs4_1d03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports